import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import { ASSETS_CDN_URL, TREATMENT_REC_PRIMARY_CARD_CDN_PREFIX as namespace } from '../../constants'
import { tID } from '../../utils'
import { Image } from '../image/Image'

const ImageSizer = styled(Image)<{ height: string; width: string }>(({ height, width }) => ({
  width,
  height,
}))

const Container = styled.View({
  overflow: 'hidden',
})

const IMAGE_SIZES = {
  DESKTOP: {
    height: '356px',
    width: '416px',
  },
  TABLET: {
    height: '300px',
    width: '354px',
  },
  MOBILE: {
    height: '190px',
    width: '343px',
  },
}

/**
 * Illustration to show on the treatment card for Meds Consultation
 */
export const MedsRec: FunctionComponent<MedsRecProps> = ({ viewport = 'DESKTOP' }) => {
  const uri = ASSETS_CDN_URL + namespace + 'meds' + viewport + '.png'
  return (
    <Container>
      <ImageSizer {...IMAGE_SIZES[viewport]} testID={`${tID('MedsRecIllustration')}`} source={{ uri }} />
    </Container>
  )
}

export type MedsRecProps = {
  viewport?: 'DESKTOP' | 'TABLET' | 'MOBILE'
}
